import { CMS_BASE_URL } from './constants'

const CMS_PREVIEW_TOKEN_HEADER = 'X-Strapi-Preview-Token'

export const buildStrapiRequestUrl = (endpoint: string, previewToken?: string): string => {
  const url = new URL(endpoint, CMS_BASE_URL)

  if (previewToken) {
    url.searchParams.set('status', 'draft')
  }

  return url.toString()
}

export const buildStrapiRequestHeaders = (previewToken?: string): HeadersInit => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
  }

  if (previewToken) {
    headers[CMS_PREVIEW_TOKEN_HEADER] = previewToken
  }

  return headers
}
